/**
 * Truncate to `digits` fraction digits, the way Intl's roundingMode 'trunc' does:
 * on the number's shortest decimal representation, not on its exact binary value.
 * (0.29 is stored as 0.289999999999999980; cutting that would give 0.28, and so
 * would Math.trunc(value * 100) / 100.)
 *
 * We do this ourselves because roundingMode is Intl.NumberFormat v3 -- Safari 15.4+,
 * Chrome 106+, Firefox 116+ -- and older engines ignore the option silently and
 * round instead. Truncating first leaves Intl nothing to round anywhere.
 *
 * Numbers in exponential form are out of scope; the scores we format never reach it.
 */
export function truncateDecimals(value: number, digits: number): number {
    const s = value.toString();
    const dot = s.indexOf('.');

    // No fraction to cut -- which also covers Infinity and NaN.
    if (dot < 0 || s.length - dot - 1 <= digits) return value;

    return Number(digits > 0 ? s.slice(0, dot + 1 + digits) : s.slice(0, dot));
}
